package com.exura.components.pageTypography

import androidx.compose.runtime.Composable
import com.exura.primary
import com.exura.ui.Dimens
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette

@Composable
internal fun NumberedStep(stepNumber: Int) {
    Box(
        modifier = stepNumberStyle.toModifier(),
        contentAlignment = Alignment.Center,
    ) { SpanText(stepNumber.toString()) }
}

val stepNumberStyle = CssStyle {
    val palette = colorMode.toPalette()
    base {
        Modifier
            .size(Dimens.stepNumberSize)
            .fontSize(Dimens.stepNumberRelFontSize)
            .borderRadius(Dimens.stepNumberBorderRadius)
            .backgroundColor(palette.primary)
            .color(palette.background)
            .flexShrink(0)
            .flexGrow(0)
    }
}
